<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>
        <u>DETAILED REPORT</u>
      </strong>
      <button class="btn btn-sm btn-primary pull-right" (click)="download()">Download</button>
    </span>
  </div>

  <!-- <div>
    <input type="button" value="CPTURE" (click)="captureScreen()" />
  </div> -->
  <div class="card-block watermark" id="divId">
    <div class="row">
      <div class="col-lg-12">
        <div class="cat__top-bar__right">
          
            <span class="company-logo-label" *ngIf="companyLogo != undefined">
              <img id="clientCompanyLogo" [src]="companyLogo" style="height:50px;margin-right:20px;" alt="Company logo">
            </span>
          
          <span *ngIf="companyLogo == undefined">
            
          </span>
          <!-- <span class="company-name-label">{{companyName}}</span> -->
        </div>
        <!-- <div>
          <div class="cat__top-bar__item" style="margin-left: 0px;">
            <a href="javascript: void(0);" aria-expanded="false">
              <span class="company-name-label">{{companyName}}</span>
            </a>
          </div>
        </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div id="pdfText" style="background-color: white">
          <div class="row text-center" id="pdfHeader">
            <h5 style="margin:auto;">
              <b>EVALUATION FOR {{evaluationName}}</b>
            </h5>
          </div>

          <br>

          <div class="row col-lg-12" id="pdfPeriod">
            <div class="col-lg-6">
            </div>
            <div class="col-lg-6">
              <div class="float-right">
                <h5 style="margin:auto;margin-bottom: 20px;">
                  <label>Period :</label>
                  <b>{{reportPeriodParameter}}</b>
                </h5>
              </div>
            </div>
          </div>
          <br>

          <!-- <div class="row">
                    <div class="col-lg-2">
                    </div>
                    <div class="col-md-4">
                    </div>
                  </div> -->
          <div class="row col-lg-12" id="pdfFormTitle">

            <div class="col-lg-8" style="margin-top:7px;">
              <div class="row">
                <div class="col-lg-4">
                  <label>
                    <b>QUESTIONNAIRE TITLE</b>
                  </label>
                  <span style="float:right">:</span>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>{{formTitle}}</label>
                  </div>
                </div>
              </div>

              <div class="row" id="pdfEntityName">
                <div class="col-lg-4">
                  <label>
                    <b>ENTITY</b>
                  </label>
                  <span style="float:right">:</span>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <!-- <input class="form-control" type="text" placeholder="Evaluation Type" name="evaluationType" 
                                [(ngModel)]="evaluationType"> -->
                    <label>{{evaluationType}}</label>
                  </div>
                </div>
              </div>


              <div class="row" id="pdfAssesse">
                <div class="col-lg-4">
                  <label>
                    <b>ASSESSEE</b>
                  </label>
                  <span style="float:right">:</span>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <!-- <input class="form-control" type="text" placeholder="Evaluation Type" name="evaluationType" 
                                [(ngModel)]="evaluationType"> -->
                    <label>{{assesseeReportFor}}</label>
                  </div>
                </div>
              </div>

<!--               <div class="row" id="pdfScoreRange">
                <div class="col-lg-4">
                  <label class="form-control-label">
                    <b>SCORING RANGE</b>
                  </label>
                  <span style="float:right">:</span>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <input class="form-control" type="number" placeholder="Score Range" name="scoreRange" 
                                [(ngModel)]="scoreRange" [disabled]="true">
                    <label>
                      <div class="float-left">
                        <h5>1</h5>(Lowest)
                      </div>
                      <div class="float-left" style="padding-right:20px;">
                        <h5>-</h5>
                      </div>
                      <div class="float-left">
                        <h5>{{scoreRange}}</h5>(Highest)
                      </div>
                    </label>
                  </div>
                </div>
              </div> -->
            </div>


            <div class="col-lg-4">
              <div class="table-responsive table-bordered margin-bottom-50">
                <table id="ratingScoreTable" class="table table-hover compact cell-border nowrap table-striped dataTable" style="background:transparent;">
                  <thead>
                    <tr style="background-color:#bfbfbf !important">
                      <th style="width:5%;color:#000000;">SCORE</th>
                      <th style="width:20%;color:#000000;">DESCRIPTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let particular of scoreParticulars">
                      <td style="width:5%">{{particular.Key}}</td>
                      <td style="width:20%">{{particular.Value}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- table Layout -->
        <!-- <div class="table-responsive table-bordered margin-bottom-50">
          <table datatable [dtOptions]="dtOptions" id="individualReportTable" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap table-striped dataTable"
            style="background:transparent" width="100%">
            <thead>
              <tr>
                <th style="width:5%">Sr. No.</th>
                <th style="width:95%">Evaluation Criteria</th>
              </tr>
            </thead>
            <tbody *ngFor="let questionListAgainstCriterias of questionListAgainstCriteria;let count=index">
              <tr>
                <td style="text-align:center;width:5%">{{count + 1}}</td>
                <td style="width:95%">{{questionListAgainstCriterias.EvaluationCriteria.EvaluationCriteria}}</td>
              </tr>
              <tr>
                <td colspan="2" style="padding:0%!important">
                  <table style="width:100%" class="table table-hover compact cell-border nowrap table-striped dataTable">
                    <tbody *ngFor="let question of questionListAgainstCriterias.EvaluationQuestion;let questionCount = index">
                      <td style="width:7.5%;text-align:center">{{count + 1}}.{{questionCount + 1}}</td>
                      <td style="width:92.5%">{{question.EvaluationQuestionId.QuestionText}}</td>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->

        <div id="hide_section_1">
        <button class="btn btn-sm btn-primary pull-right" onclick="(()=>document.getElementById('hide_section_1').style.display='none')()">Hide</button>
        <div class=" text-center" id="scorePerEVALUATIONCriteria">
          <h5 style="margin:auto;">
            <b>
              <u>AVERAGE SUMMARY SCORE PER EVALUATION CRITERIA</u>
            </b>
          </h5>
        </div>

        <div class="table-responsive table-bordered margin-bottom-50">
          <table id="boardAssessmentSummaryTable" class="table table-hover compact cell-border nowrap table-striped dataTable" width="100%">
            <thead>
              <tr style="background-color:#bfbfbf !important">
                <th style="width:5%;color:#000000;">Sr No.</th>
                <th style="width:20%;color:#000000;">Criteria</th>
                <th style="width:10%;color:#000000;">Weightage(%)</th>
                <th style="width:5%;color:#000000;" [hidden]="reportFormat == 'Summary'" *ngFor="let assignee of assigneeDetails;let directorCount =index">{{assignee.AssigneeDetails ? (assignee.AssigneeDetails.Title + " " + assignee.AssigneeDetails.FirstName +
                  " " + assignee.AssigneeDetails.LastName ) : ("Director " + (directorCount +1)) }}</th>
                <th style="width:15%;color:#000000;">Average Score Across Directors</th>
                <th style="width:15%;color:#000000;">Weighted Average Score</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let calculatedCriteriaScore of calculatedCriteriaScoreArray;let count = index;">
                <td style="width:5%">{{count + 1 }}</td>
                <td style="width:20%;white-space:normal;">{{calculatedCriteriaScore.EvaluationCriteria}}</td>
                <td style="width:10%">{{calculatedCriteriaScore.CriteriaWeight}}</td>
                <td style="width:5%" [hidden]="reportFormat == 'Summary'" *ngFor="let assignee of assigneeDetails">{{assignee.calculatedCriteriaScore[count].categoryScore}}</td>
                <td style="width:15%">{{calculatedCriteriaScore.averageScore}}</td>
                <td style="width:15%">{{calculatedCriteriaScore.averageWeightedScore.averageWeightedScore}}</td>
              </tr>
              <tr style="background-color:#32849c !important">
                <td style="width:5%;color:#000000">FINAL SCORE</td>
                <td style="width:20%"></td>
                <td style="width:10%"></td>
                <td style="width:5%" [hidden]="reportFormat == 'Summary'" *ngFor="let assignee of assigneeDetails"></td>
                <td style="width:15%"></td>
                <!-- <td></td>
                <td></td> -->
                <td style="color:#000000;">{{totalAverageWeightedScore}}</td>
              </tr>
              <!-- <tr>
                <th style="width:5%">Final Score</th>
                <th style="width:20%"></th>
                <th style="width:10%"></th>
                <th style="width:10%">5</th>
                <th style="width:5%">3</th>
                <th style="width:5%">4</th>
                <th style="width:5%">5</th>
                <th style="width:5%">4.6</th>
                <th style="width:5%">4</th>
                <th style="width:15%"></th>
                <th style="width:15%">4.27</th>
              </tr> -->
            </tbody>
          </table>
        </div>
        <br>

        <div class="row" style="width:100%">
          <div id="weightedBarChart" class="m-auto" style="cursor: pointer;">
            <chart [options]="weigthedBarGraphOptions"></chart>
          </div>
        </div>
      </div>
        <div id="hide_section_2">
        <button class="btn btn-sm btn-primary pull-right" onclick="(()=>document.getElementById('hide_section_2').style.display='none')()">Hide</button>      
        <hr style="border-top: dotted 1px;" />
        <br>
        <div class=" text-center" id="scorePerCriteriaPerQuestion">
          <h5 style="margin:auto;">
            <b>
              <u>AVERAGE SCORE PER CRITERIA, PER QUESTION</u>
            </b>
          </h5>
        </div>
        
        <div class="table-responsive table-bordered margin-bottom-50">
          <table id="boardAssessmentSummaryTableAgainstQuestion" class="table table-hover compact cell-border nowrap table-striped dataTable"
            style="background:transparent" width="100%">
            <thead>
              <tr style="background-color:#d9d9d9;">
                <th style="width:5%;color:#000000;">Sr no.</th>
                <th style="width:40%;color:#000000;">Criteria</th>
                <!-- <th style="width:20%">Ref in Previous template</th> -->
                <th style="color:#000000;" *ngFor="let particular of scoreParticulars">{{particular.Value}}</th>
                <th style="width:10%;color:#000000;">Average Score</th>
              </tr>
              <tr style="background-color:#d9d9d9;">
                <th style="width:5%"></th>
                <th style="width:40%"></th>
                <th style="color:#000000;" *ngFor="let particular of scoreParticulars;let i = index;">({{ i+1}})</th>
                <th style="width:10%"></th>
              </tr>
            </thead>
            <tbody *ngFor="let calculatedCriteriaScore of calculatedCriteriaScoreArray;let count = index;">
              <!-- <tr>
                <td style="width:5%"></td>
                <td style="width:40%"></td>
                <td style="width:20%"></td>
                <td style="width:5%">1</td>
                <td style="width:5%">2</td>
                <td style="width:5%">3</td>
                <td style="width:5%">4</td>
                <td style="width:5%">5</td>
                <td style="width:10%"></td>
              </tr> -->
              <tr style="background-color:#bfbfbf !important;">
                <td style="width:5%;color:#000000;">{{count + 1 }}</td>
                <td style="width:40%;white-space:normal;color:#000000;">
                  <b>{{calculatedCriteriaScore.EvaluationCriteria}}</b>
                </td>
                <td *ngFor="let particular of scoreParticulars"></td>
                <td style="width:20%"></td>
              </tr>
              <tr *ngFor="let question of calculatedCriteriaScore.Answers;let questionCount = index">
                <td style="width:5%;text-align:center">{{count + 1}}.{{questionCount + 1}}</td>
                <td style="width:40%;word-wrap: break-word;white-space:normal;">{{question.QuestionText}}</td>
                <td *ngFor="let particular of scoreParticulars; let scoreCount = index" style="text-align: center">
                  <!-- <span>{{(averageCriteriaQuestionAnswer[questionCount].score ? (((averageCriteriaQuestionAnswer[questionCount].score >= (scoreCount + 1)) && (averageCriteriaQuestionAnswer[questionCount].score < (scoreCount + 2)) ) ? averageCriteriaQuestionAnswer[questionCount].score : "" ) : "" )}}</span> -->
                  <span>{{showAverageQuestionAnswer(question.QuestionId , scoreCount)}}</span>
                </td>
                <td style="width:5%"></td>
                <!-- <td style="width:10%"></td> -->
                <!-- <td style="width:5%">{{calculatedCriteriaScore.averageWeightedScore}}</td>
                <td style="width:5%">{{calculatedCriteriaScore.averageWeightedScore}}</td>
                <td style="width:10%">{{calculatedCriteriaScore.averageWeightedScore}}</td> -->
              </tr>
              <tr style="background-color:#32849c !important">
                <td style="width:5%"></td>
                <td style="width:40%;color:#000000;">Sub Total</td>
                <td *ngFor="let particular of scoreParticulars"></td>
                <td style="width:20%;color:#000000;">{{calculatedCriteriaScore.averageScore}}</td>
              </tr>

              <!-- <tr>
                  <th style="width:5%">Final Score</th>
                  <th style="width:20%"></th>
                  <th style="width:10%"></th>
                  <th style="width:10%">5</th>
                  <th style="width:5%">3</th>
                  <th style="width:5%">4</th>
                  <th style="width:5%">5</th>
                  <th style="width:5%">4.6</th>
                  <th style="width:5%">4</th>
                  <th style="width:15%"></th>
                  <th style="width:15%">4.27</th>
                </tr> -->
            </tbody>
          </table>
        </div>
</div>


        <div class=" text-center" id="scorePerCriteriaPerQuestion">
          <h5 style="margin:auto;margin-top: 3%;">
            <b>
              <u>SCORE PER CRITERIA, PER QUESTION, PER ASSESSOR</u>
            </b>
          </h5>
        </div>


        <div class="table-responsive table-bordered margin-bottom-50">
          <table id="boardAssessmentSummaryTableAgainstQuestion" class="table table-hover compact cell-border nowrap table-striped dataTable"
            style="background:transparent" width="100%">
            <thead>
              <tr style="background-color:#d9d9d9;">
                <th style="width:5%;color:#000000;">Sr no.</th>
                <th style="width:40%;color:#000000;">Criteria</th>
                <th style="width:40%;color:#000000;">Question</th>
                <th style="color:#000000;" *ngFor="let assignee of assigneeDetails;let directorCount =index">{{assignee.AssigneeDetails ? (assignee.AssigneeDetails.Title + " " + assignee.AssigneeDetails.FirstName +
                  " " + assignee.AssigneeDetails.LastName ) : ("Director " + (directorCount +1)) }}</th>
              </tr>
            </thead>

  <tbody>
    <tr  *ngFor="let assigneeDetailsList of assigneeDetailsAnswerDetails; let countIndex = index;">
      <td style="width:5%;color:#000000;">{{countIndex + 1 }}</td>
      <td  style="width:40%;white-space:normal;color:#000000;">
        <b>{{assigneeDetailsList.EvaluationCriteria}}</b>
      </td>
      <td  style="width:40%;white-space:normal;color:#000000;">
        {{assigneeDetailsList.QuestionText}}
      </td>
      <td *ngFor="let assignee of assigneeDetails;let directorCount =index" style="text-align: center">
        <span>{{assigneeDetailsList['director-'+directorCount]}}</span>
      </td>                      
    </tr>


    <!-- <tr style="background-color:#bfbfbf !important;" *ngFor="let assigneeDetailsList of assigneeDetails[0].AnswerDetails;let countIndex = index;">
      <td style="width:5%;color:#000000;">{{countIndex + 1 }}</td>
      <td  style="width:40%;white-space:normal;color:#000000;">
        <b>{{assigneeDetailsList.QuestionText}}</b>
      </td>
      <td *ngFor="let assignee of assigneeDetails;let directorCount =index" style="text-align: center">
        <span>{{assigneeDetailsList['director-'+directorCount]}}</span>
      </td>                      
    </tr> -->


                <!-- <tbody *ngFor="let assigneeDetailsList of assigneeDetails;let countIndex = index;" >
                    <tr style="background-color:#bfbfbf !important;">
                      <td style="width:5%;color:#000000;">{{countIndex + 1 }}</td>
                      <td *ngFor="let calculatedCriteriaScore of assigneeDetailsList.calculatedCriteriaScore;let count = index;" style="width:40%;white-space:normal;color:#000000;">
                        <b>{{calculatedCriteriaScore.EvaluationCriteria}}</b>
                      </td>
                      <td *ngFor="let particular of scoreParticulars; let scoreCount = index" style="text-align: center">
                        <span>{{showAverageQuestionAnswer(question.QuestionId , scoreCount)}}</span>
                      </td>                      
                      <td style="width:20%"></td>
                    </tr> -->





                    <!--                       <td *ngFor="let particular of scoreParticulars"></td> -->
                    <!--                     <tr *ngFor="let question of calculatedCriteriaScore.Answers;let questionCount = index">
                      <td style="width:5%;text-align:center">{{countIndex + 1}}.{{questionCount + 1}}</td>
                      <td style="width:40%;word-wrap: break-word;white-space:normal;">{{question.QuestionText}}</td>
                      <td *ngFor="let particular of scoreParticulars; let scoreCount = index" style="text-align: center">
                        <span>{{showAverageQuestionAnswer(question.QuestionId , scoreCount)}}</span>
                      </td>
                    </tr> -->
                    <!-- <tr *ngIf="assigneeDetailsLength==countIndex+1" style="background-color:#32849c !important">
                      <td style="width:5%"></td>
                      <td style="width:40%;color:#000000;">Sub Total</td>
                      <td *ngFor="let particular of scoreParticulars"></td>
                      <td style="width:20%;color:#000000;">{{calculatedCriteriaScore.averageScore}}</td>
                    </tr> -->
                </tbody>
<!--             </ng-container> -->
          </table>
        </div>



        <span *ngIf="reportFormat != 'Summary'">


        <hr style="border-top: dotted 1px;" />
        <br>

        <div class="row">
          <div class="col-lg-12">
            <div id="pdfText" style="background-color: white">
              <div class="row text-center" id="scorePerCriteriaPerQuestion">
                <h5 style="margin:auto;">
                  <b>
                    <u>Comments</u>
                  </b>
                </h5>
              </div>
              <br>
            </div>
          </div>
        </div>


        <div class="table-responsive table-bordered margin-bottom-50">
          <table id="boardAssessmentCommentsTable" class="table table-hover compact cell-border nowrap table-striped dataTable"
            style="background:transparent" width="100%">

            <thead>
              <tr style="background-color:#d9d9d9;">
                <th style="width:5%;color:#000000;">Sr no.</th>
                <th style="width:40%;color:#000000;">Comments Provided by</th>
                <th style="width:55%;color:#000000;">Comments</th>
              </tr> 
            </thead>

            <tbody>
              <tr *ngFor="let assignee of assigneeDetails;let directorCount =index">
                <td>{{directorCount + 1}}</td>
                <td>{{assignee.AssigneeDetails ? (assignee.AssigneeDetails.Title + " " + assignee.AssigneeDetails.FirstName +
                  " " + assignee.AssigneeDetails.LastName ) : ("Director " + (directorCount +1)) }}</td>
                <td>
                  <pre style="white-space: pre-line!important;">
                     {{(assignee.comments == "")  ? "Not Available" : assignee.comments.toString().trim()}}                  
                  </pre>                              
                </td>
              </tr>
            </tbody>

          </table>
        </div>

      </span>


      </div>
    </div>
  </div>


  <!-- <div class="card-footer">
      <span class="cat__core__title">
          <button class="btn btn-sm btn-primary" (click)="download()">download</button>
      </span>
    </div> -->

  <!-- <div class="pull-right">
    <button class="btn btn-sm btn-primary" (click)="download()">download</button>
  </div> -->

</section>